import React, { useEffect, useState } from 'react';
import { certificateApi } from '../../services/certificateApi';

const newerStateLabel = (state) => {
  if (state === 'vigente') return 'publicada';
  if (state === 'borrador') return 'pendiente de publicación';
  return state || 'más reciente';
};

export const CertificatePublicationConflicts = ({
  batch,
  running = false,
  onCancelIssuance = () => {},
}) => {
  const [conflicts, setConflicts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const idLote = Number(batch?.id_lote);
  const shouldLoad = Boolean(
    Number.isInteger(idLote) &&
      idLote > 0 &&
      batch?.estado_publicacion === 'borrador' &&
      batch?.estado === 'completado',
  );

  useEffect(() => {
    let active = true;

    if (!shouldLoad) {
      setConflicts([]);
      setLoading(false);
      setError('');
      return () => {
        active = false;
      };
    }

    setLoading(true);
    setError('');

    certificateApi
      .listPublicationConflicts(idLote)
      .then((rows) => {
        if (active) {
          setConflicts(Array.isArray(rows) ? rows : []);
        }
      })
      .catch(() => {
        if (active) {
          setConflicts([]);
          setError('No fue posible comprobar si existen versiones más recientes.');
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [
    idLote,
    shouldLoad,
    batch?.exitosos,
    batch?.cancelados,
  ]);

  if (!shouldLoad) return null;

  if (loading) {
    return (
      <p className="certificate-batch-state" role="status">
        Verificando versiones anteriores de las constancias...
      </p>
    );
  }

  if (error) {
    return (
      <p className="certificate-wizard-status" role="status">
        {error}
      </p>
    );
  }

  if (conflicts.length === 0) return null;

  return (
    <section className="certificate-publication-conflicts" aria-label="Conflictos de publicación">
      <p className="certificate-wizard-status" role="alert">
        {conflicts.length === 1
          ? 'Hay una constancia obsoleta en este lote. Existe una versión más reciente y debe quitarse antes de publicar.'
          : `Hay ${conflicts.length} constancias obsoletas en este lote. Existen versiones más recientes y deben quitarse antes de publicar.`}
      </p>
      <ul className="certificate-batch-students">
        {conflicts.map((conflict) => (
          <li key={conflict.id_emision}>
            <span>{conflict.nombre_alumno}</span>
            <div className="certificate-batch-student-actions">
              <strong>Versión obsoleta</strong>
              <small>
                Versión más reciente en lote {conflict.id_lote_mas_reciente}
                {conflict.id_emision_mas_reciente
                  ? `, emisión ${conflict.id_emision_mas_reciente}`
                  : ''}
                {` (${newerStateLabel(conflict.estado_mas_reciente)})`}
              </small>
              {!running && conflict.id_emision && (
                <button
                  type="button"
                  className="danger-link"
                  onClick={() =>
                    onCancelIssuance({
                      id_alumno: conflict.id_alumno,
                      id_emision: conflict.id_emision,
                      nombre_alumno: conflict.nombre_alumno,
                    })
                  }
                >
                  Quitar versión obsoleta
                </button>
              )}
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
};
